'use strict';

const Moment = require('moment');
const Backbone = require('backbone');
const CommentReactionActionCollection = require('communication/domain/comment-reaction/action-collection');
const CommentReactionActionFactory = require('communication/domain/comment-reaction/action-factory');

class CommentReaction extends Backbone.Model {
    static get defaults() {
        return {
            name: null,
            actions: [],
            count: 0,
            _project: null
        };
    }

    constructor(params) {
        super(params);
        this._actions = new CommentReactionActionCollection(this.get('actions'));
        this._actions.on('add', () => {
            this.trigger('change:actions');
        });
        this._actions.on('remove', () => {
            this.trigger('change:actions');
        });
    }

    get name() {
        return this.get('name');
    }

    get actions() {
        return this._actions;
    }

    get count() {
        return this.get('count');
    }

    get firstActionAt() {
        if (this.actions.length === 0) {
            return;
        }

        return this.actions[0].actionAt;
    }

    hasByUserKey(userKey) {
        return this._actions.hasByUserKey(userKey);
    }

    addAction(userKey, actionAt = null) {
        const action = this._actions.getByUserKey(userKey);
        if (action && actionAt && action.actionAt <= Moment(actionAt)) {
            action.set({actionAt: Moment(actionAt).format()});
        }
        if (action) {
            return new Promise(resolve => {
                resolve(action);
            });
        }

        const project = this.get('_project');
        const actionJSON = {
            userKey: userKey.toString(),
            actionAt: actionAt || Moment().format()
        };
        return new CommentReactionActionFactory(project)
            .build(actionJSON)
            .then(action => {
                this._actions.add(action);
            });
    }

    removeAction(userKey) {
        const action = this._actions.getByUserKey(userKey);
        if (!action) {
            return;
        }

        this._actions.remove(action);
        this.set({count: this._actions.length});
    }

    isEmptyActions() {
        return this.count === 0;
    }
}

module.exports = CommentReaction;



// WEBPACK FOOTER //
// ./communication/domain/comment-reaction/reaction.js